import { Button } from "../components/ui/button";
import { ArrowRight, Zap, Leaf, DollarSign } from "lucide-react";
import heroImage from "../assets/hero-solar.jpg";

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-transparent"></div>
      </div>
      
      {/* Content */}
      <div className="relative container mx-auto px-4 py-20 grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-center lg:text-left">
          <h1 className="text-5xl lg:text-7xl font-bold mb-6 text-primary-foreground">
            Power Your Future with
            <span className="block bg-gradient-energy bg-clip-text text-transparent">
              Solar Energy
            </span>
          </h1>
          <p className="text-xl lg:text-2xl mb-8 text-primary-foreground/90 leading-relaxed">
            PASAT COMPANY provides premium solar panel installations that reduce your energy costs and environmental footprint.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              variant="hero" 
              size="lg"
              onClick={scrollToContact}
              className="group"
            >
              Get Free Quote
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary"
            >
              Learn More
            </Button>
          </div>
          
          <div className="grid grid-cols-3 gap-6 text-center">
            <div className="bg-background/10 backdrop-blur-sm rounded-lg p-4">
              <Zap className="h-8 w-8 text-solar-yellow mx-auto mb-2" />
              <p className="text-primary-foreground font-semibold">Clean Energy</p>
            </div>
            <div className="bg-background/10 backdrop-blur-sm rounded-lg p-4">
              <DollarSign className="h-8 w-8 text-solar-green mx-auto mb-2" />
              <p className="text-primary-foreground font-semibold">Save Money</p>
            </div>
            <div className="bg-background/10 backdrop-blur-sm rounded-lg p-4">
              <Leaf className="h-8 w-8 text-solar-green mx-auto mb-2" />
              <p className="text-primary-foreground font-semibold">Eco-Friendly</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;